import React from 'react'
import { BsArrowRight } from 'react-icons/bs'
import {CgClose} from 'react-icons/cg'

function PopUp({data,popUpVisible,setPopUpVisible}) {
  return (
    <div onClick={e => {setPopUpVisible(false)}} className={` ${popUpVisible ? 'block' : 'hidden'} flex gap-10 flex-col justify-center items-center fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.7)] z-[100]`}>
        <div className='fixed top-5 right-5 text-white cursor-pointer text-4xl'><CgClose /></div>
        <div className=' w-2/3 sm:w-1/2 lg:w-1/3 aspect-square'>
            <img src={data.image} alt="data image" className=' w-full h-full object-contain' srcset="" />
        </div>
        <div>
            <a href="#" target="_blank" rel="noopener noreferrer" className=' text-white flex items-center gap-3 px-5 py-3 rounded-md bg-blue-700'>Payer la formation <span className=' text-xl'><BsArrowRight /></span></a>
        </div>
    </div>
  )
}

export default PopUp